import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import Cookies from "js-cookie";
import { FaEye, FaEyeSlash, FaUser, FaLock, FaChartLine } from "react-icons/fa";

const baseURL = import.meta.env.VITE_API_URL;

const Login = () => {
  const { setAuthData } = useAuth();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [alerts, setAlerts] = useState(false);
  const [pesan, setPesan] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedUserName = localStorage.getItem("userName");
    const savedPassword = localStorage.getItem("password");

    if (savedUserName && savedPassword) {
      setUserName(savedUserName);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (rememberMe) {
      localStorage.setItem("userName", userName);
      localStorage.setItem("password", password);
    } else {
      localStorage.removeItem("userName");
      localStorage.removeItem("password");
    }
    setLoading(true);
    handleLogin();
  };

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${baseURL}/user/login`, {
        UserName: userName,
        UserPwd: password,
      });
      localStorage.setItem("dataLogin", JSON.stringify(response.data));
      Cookies.set("token", response.data.Token);
      const userData = response.data;
      setAuthData(userData);
      navigate("/home");
    } catch (error) {
      setPesan("Wrong UserName or Password.");
      setAlerts(true);
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <section className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('/img/pattern.svg')] opacity-10"></div>
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/20 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-slate-500/20 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>

        <div className="relative z-10 flex flex-col items-center justify-center w-full p-12 text-white">
          <img className="w-56 mb-8 drop-shadow-2xl" src="/img/MMG.png" alt="logo MMG" />
          <h1 className="text-4xl font-bold tracking-tight mb-4 text-center">MAJU MOTOR GROUP</h1>
          <p className="text-slate-300 text-lg text-center max-w-md">
            Enterprise Management System
          </p>
          <div className="mt-12 grid grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold">Fast</div>
              <div className="text-slate-400 text-sm">Performance</div>
            </div>
            <div>
              <div className="text-3xl font-bold">Secure</div>
              <div className="text-slate-400 text-sm">Platform</div>
            </div>
            <div>
              <div className="text-3xl font-bold">Smart</div>
              <div className="text-slate-400 text-sm">Solutions</div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex flex-col items-center mb-8">
            <img className="w-36 mb-4" src="/img/MMG.png" alt="logo MMG" />
            <h1 className="text-2xl font-bold text-slate-800">MAJU MOTOR GROUP</h1>
          </div>

          <div className="bg-white rounded-2xl shadow-xl shadow-slate-900/5 p-8 border border-slate-200/60">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800">Welcome Back</h2>
              <p className="text-slate-500 mt-1">Sign in to your account</p>
            </div>

            {alerts && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-red-600 text-xs font-bold">!</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-red-800">{pesan}</p>
                  <p className="text-xs text-red-600 mt-0.5">Please check your credentials</p>
                </div>
              </div>
            )}

            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="userName" className="block text-sm font-semibold text-slate-700 mb-2">
                  Username
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaUser className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type="text"
                    name="userName"
                    id="userName"
                    className="block w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-transparent transition-all duration-200"
                    placeholder="Enter your username"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-semibold text-slate-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaLock className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="Enter your password"
                    className="block w-full pl-10 pr-12 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-transparent transition-all duration-200"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash className="h-4 w-4" /> : <FaEye className="h-4 w-4" />}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <label className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    className="w-4 h-4 text-slate-600 border-slate-300 rounded focus:ring-slate-500 focus:ring-2 transition-colors"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="ml-2 text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
                    Remember me
                  </span>
                </label>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 px-4 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white font-semibold rounded-xl shadow-lg shadow-slate-600/30 hover:shadow-slate-700/40 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Signing in...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>

            <div className="mt-6 pt-6 border-t border-slate-200">
              <button
                type="button"
                onClick={() => navigate("/kpi")}
                className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl shadow-lg shadow-blue-600/30 hover:shadow-blue-700/40 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center gap-2"
              >
                <FaChartLine className="h-4 w-4" />
                Go to KPI Dashboard
              </button>
            </div>
          </div>

          <p className="text-center text-slate-500 text-sm mt-6">
            &copy; {new Date().getFullYear()} Maju Motor Group. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Login;
